export default __webpack_public_path__ + "static/media/whatsappColored.955ab71e.svg";